module.exports = __webpack_public_path__ + "static/media/mayo-instrument.85f4256d.mp3";